import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";

import { cn } from "@/app/common/common-functions/functions";

const Slider = React.forwardRef<React.ElementRef<typeof SliderPrimitive.Root>, React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>>(
  ({ className, ...props }, ref) => (
    <SliderPrimitive.Root ref={ref} className={cn("tw-relative tw-flex tw-w-full tw-touch-none tw-select-none tw-items-center", className)} {...props}>
      <SliderPrimitive.Track className="tw-bg-primary/20 tw-relative tw-h-1.5 tw-w-full tw-grow tw-overflow-hidden tw-rounded-full">
        <SliderPrimitive.Range className="tw-absolute tw-h-full tw-bg-primary" />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb className="tw-border-primary/50 tw-block tw-h-4 tw-w-4 tw-rounded-full tw-border tw-bg-background tw-shadow tw-transition-colors focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-ring disabled:tw-pointer-events-none disabled:tw-opacity-50" />
    </SliderPrimitive.Root>
  )
);
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
